import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LifeycleTransitionFilterPipe } from './lifeycle-transition-filter.pipe';

@NgModule({
  declarations: [LifeycleTransitionFilterPipe],
  imports: [CommonModule],
  exports: [LifeycleTransitionFilterPipe],
})
export class LifecycleTransitionFilterPipeModule {}
